// 组件对象，大写
import crudQueryForSideModal from './crudQueryForSideModal.vue'
export default crudQueryForSideModal
